import { BookItsElemental, BookBigExperiments, BookEdibleExperiments, BookStemNight, BookGreatEscape, BookPenguinProblems, BookBdayBlastoff, BookScienceOfSlime, BookDragonsUnicorns } from './Images.js';
import LazyImage from './components/LazyImage';
import { BookOneListData, BookTwoListData, BookThreeListData, BookFourListData, BookFiveListData, BookSixListData, BookSevenListData, BookEightListData } from './BookListData.js';
import { Link } from 'react-router-dom';

function BookListConstructor(bookID) {
    // Map book IDs to their corresponding link data
    const bookLinkData = {
        1: BookOneListData,
        2: BookTwoListData,
        3: BookThreeListData,
        4: BookFourListData,
        5: BookFiveListData,
        6: BookSixListData,
        7: BookSevenListData,
        8: BookEightListData
    };

    const linkData = bookLinkData[bookID];
    if (!linkData) {
        return <></>;
    }

    // Store display names and their corresponding link keys
    const storeLinks = [
        { name: 'Amazon', key: 'amazon_link' },
        { name: 'Barnes & Noble', key: 'barnes_and_noble_link' },
        { name: 'Apple Books', key: 'apple_books_link' },
        { name: 'Google Books', key: 'google_books_link' },
        { name: 'Kobo', key: 'kobo_link' },
        { name: 'Audible', key: 'audible_link' },
        { name: 'Libro.fm', key: 'librofm_link' },
        { name: 'BookPeople', key: 'bookpeople_link' }
    ];

    // Generate links only for stores that have URLs
    const availableLinks = storeLinks
        .filter(store => linkData[store.key] && linkData[store.key].trim() !== "")
        .map(store => (
            <a 
                key={store.key}
                href={linkData[store.key]} 
                target="_blank" 
                rel="noopener noreferrer"
                className="book-link"
            >
                {store.name}
            </a>
        ));

    return (
        <div className="book-links">
            {availableLinks.length > 0 ? (
                <>
                    <h4>Available at:</h4>
                    <div className="book-links-container">
                        {availableLinks}
                    </div>
                </>
            ) : null}
        </div>
    );
}

const BookOne = {
    title: "It's Elemental",
    subtitle: <>The Hidden Chemistry in Everything
    <br />
    Published: July 2021</>,
    desc: <>In this fresh and engaging guide to chemistry, Dr. Kate Biberdorf, aka "Kate the Chemist," reveals the fascinating science we experience every day Have you ever wondered what makes dough rise? Or how your morning coffee gives you that energy boost? Or why your shampoo is making your hair look greasy? The answer is chemistry. From the moment we wake up until the time we go to sleep (and even while we sleep), chemistry is at work—and it doesn't take a PhD in science to understand it.
    <br /><br />
    Praise for It's Elemental:
    "Readers will come away with an appreciation of how crucial—and how cool—chemistry actually is." - Publishers Weekly (starred review)
     <br /><br />
    "With a wittiness that most science-explainers lack, It's Elemental should be a welcome respite for those seeking knowledge." - Booklist
    </>,
    image: BookItsElemental,
    links: BookListConstructor(1)
}

const BookTwo = {
    title: "The Big Book of Experiments",
    subtitle: <>*An Amazon Best Book of 2020* The experiments are all designed and presented in a way, not just to make science fun, but to make it accessible for all ages and interest levels. This is a great book to follow if you are currently homeschooling across multiple grade levels. --GeekMom.com</>,
    desc: <>25 At Home Experiments
    Published: May 2020
    <br /><br />
    Have you ever wondered how to make a volcano explode? Or why dropping dry ice in soap bubbles forms neon brains? With these 25 kid-friendly science experiments Kate the Chemist's big book of experiments, shows kids just how fun--and easy--it is to be a scientist.
    <br /><br />
    Learn to make:

    <ul>
        <li>slime</li>
        <li>fake tattoos</li>
        <li>edible snot</li>
        <li>and more!</li>
    </ul>
    Each experiment includes step-by-step instructions, an ingredients list, full color photographs, a messiness factor rating, and a note from chemistry professor and science entertainer, Kate the Chemist! Create future engineers, scientists, and inventors, and introduce your child to the world of STEM with Kate the Chemist: The Big Book of Experiments!</>,
    image: BookBigExperiments,
    links: BookListConstructor(2)
}

const BookThree = {
    title: "The Awesome Book of Edible Experiments for Kids",
    subtitle: <>25 Edible Experiments
    <br /><br />
    Published: May 2021</>,
    desc: <>Did you know that all cooking is really chemistry? And that chocolate chip cookies will look--and taste--completely different if you swap out baking powder for baking soda? Or swap out brown sugar for white sugar? In this cookbook packed with 25 edible science experiment recipes kids can do in their own kitchen, chemistry professor and science entertainer Kate the Chemist introduces young scientists to the fascinating world of STEM--and cooking!
    <br /><br />
    
    Kids can make their own:
    <ul>
    <li>Chocolate-covered pretzels</li>
    <li>Rainbow pasta</li>
    <li>Ice cream</li>
    <li>Pretzel bites</li>
    and more!
    </ul>
     
    Each recipe includes step-by-step instructions, an ingredients list, full-color photographs, a messiness factor rating, and a note from Kate explaining the science behind each delicious treat.
     
    Praise for the Awesome Book of Edible Experiments for Kids:

    *An Amazon Best Book of May*</>,
    image: BookEdibleExperiments,
    links: BookListConstructor(3)
}

const BookFour = {
    title: "Kate the Chemist: The STEM Night Disaster",
    subtitle: <>The third installment of the Kate the Chemist fiction series
    <br /><br />
    Published: January 2021</>,
    desc: <>The STEM Night Disaster shows kids that everyone can be a scientist! Perfect for fans of the Girls Who Code series. Kate's school is having their first-ever STEM Night and the prizes are incredible! Kate is determined to win and comes up with the perfect experiment. But as she and her best friend, Birdie, start preparing, they find that Kate's project keeps getting messed up. Will Kate be able to use her science know-how to find out who is behind the STEM night sabotage? And will she fix her project before it's too late? From Kate the Chemist, chemistry professor and science entertainer as seen on The Late Show with Stephen Colbert, The Wendy Williams Show, and The Today Show, comes a clever and fun middle grade series that is the perfect introduction to STEM for young readers! Make Your Own Lemon Battery! Experiment Inside!
    <br /><br />
    Praise for the Kate the Chemist fiction series:
    "Proves that science and fun go together like molecules in a polymer."
    --School Library Journal
     <br /><br />
    "It's a great introduction to the basics of Chemistry that is readily accessible to a variety of ages . . . . The way the everyday chemistry is blended in is done seamlessly, and has [me and my ten-year-old son] noticing how we are all doing a little bit of science everyday."
    --GeekMom.com</>,
    image: BookStemNight,
    extra: 
        <><br /><br />Other books from this series:
            <br />
            <br />
            <Link to={`/books/bookeight`}>
                <LazyImage className="book-extra-img" src={ BookDragonsUnicorns } alt="Dragons vs. Unicorns book cover" />
            </Link>
            <Link to={`/books/bookfive`}>
                <LazyImage className="book-extra-img" src={ BookGreatEscape } alt="The Great Escape book cover" />
            </Link>
            <Link to={`/books/bookseven`}>
                <LazyImage className="book-extra-img" src={ BookBdayBlastoff } alt="The Birthday Blastoff book cover" />
            </Link>
            <Link to={`/books/booksix`}>
                <LazyImage className="book-extra-img" src={ BookPenguinProblems } alt="Some Penguin Problems book cover" />
            </Link>
            
        </>,
    links: BookListConstructor(4)
}

const BookFive = {
    title: "Kate the Chemist: The Great Escape",
    subtitle: <>The second installment of the Kate the Chemist fiction series
    <br /><br />
    Published: September 2020</>,
    desc: <>The Great Escape shows kids that everyone can be a scientist! Perfect for fans of the Girls Who Code series. What do magnetic slime, a secret code, and the periodic table have in common? They're all part of the science-themed escape room that Kate's science teacher puts on for their class. Will Kate and her friends be able to use their science know-how to crack the code before time runs out? From Kate the Chemist, chemistry professor and science entertainer as seen on The Late Show with Stephen Colbert, The Wendy Williams Show, and The Today Show, comes a clever and fun middle grade series that is the perfect introduction to STEM for young readers! Make Your Own Magnetic Slime! Experiment Inside!
    <br /><br />
    Praise for the Kate the Chemist fiction series:
    "Proves that science and fun go together like molecules in a polymer."
    --School Library Journal
     <br /><br />
    "It's a great introduction to the basics of Chemistry that is readily accessible to a variety of ages . . . . The way the everyday chemistry is blended in is done seamlessly, and has [me and my ten-year-old son] noticing how we are all doing a little bit of science everyday."
    --GeekMom.com</>,
    image: BookGreatEscape,
    extra: 
        <><br /><br />Other books from this series:
            <br />
            <br />
            <Link to={`/books/bookeight`}>
                <LazyImage className="book-extra-img" src={ BookDragonsUnicorns } alt="Dragons vs. Unicorns book cover" />
            </Link>
            <Link to={`/books/bookfour`}>
                <LazyImage className="book-extra-img" src={ BookStemNight } alt="The STEM Night Disaster book cover" />
            </Link>
            <Link to={`/books/bookseven`}>
                <LazyImage className="book-extra-img" src={ BookBdayBlastoff } alt="The Birthday Blastoff book cover" />
            </Link>
            <Link to={`/books/booksix`}>
                <LazyImage className="book-extra-img" src={ BookPenguinProblems } alt="Some Penguin Problems book cover" />
            </Link>
            
        </>,
    links: BookListConstructor(5)
}

const BookSix = {
    title: "Kate the Chemist: Some Penguin Problems",
    subtitle: <>The fifth installment of the Kate the Chemist fiction series
    <br /><br />
    Published: July 2020</>,
    desc: <>Kate the Chemist: Penguin Problems shows kids that everyone can be a scientist! Perfect for fans of the Girls Who Code series. What do penguins, magnets, and the periodic table have in common? They're all part of the science-themed escape room that Kate's science teacher puts on for their class. Will Kate and her friends be able to use their science know-how to crack the code before time runs out? From Kate the Chemist, chemistry professor and science entertainer as seen on The Late Show with Stephen Colbert, The Wendy Williams Show, and The Today Show, comes a clever and fun middle grade series that is the perfect introduction to STEM for young readers! Make Your Own Magnetic Slime! Experiment Inside!
    <br /><br />
    Praise for the Kate the Chemist fiction series:
    "Proves that science and fun go together like molecules in a polymer."
    --School Library Journal
     <br /><br />
    "It's a great introduction to the basics of Chemistry that is readily accessible to a variety of ages . . . . The way the everyday chemistry is blended in is done seamlessly, and has [me and my ten-year-old son] noticing how we are all doing a little bit of science everyday."
    --GeekMom.com</>,
    image: BookPenguinProblems,
    extra: 
        <><br /><br />Other books from this series:
            <br />
            <br />
            <Link to={`/books/bookeight`}>
                <LazyImage className="book-extra-img" src={ BookDragonsUnicorns } alt="Dragons vs. Unicorns book cover" />
            </Link>
            <Link to={`/books/bookfive`}>
                <LazyImage className="book-extra-img" src={ BookGreatEscape } alt="The Great Escape book cover" />
            </Link>
            <Link to={`/books/bookfour`}>
                <LazyImage className="book-extra-img" src={ BookStemNight } alt="The STEM Night Disaster book cover" />
            </Link>
            <Link to={`/books/bookseven`}>
                <LazyImage className="book-extra-img" src={ BookBdayBlastoff } alt="The Birthday Blastoff book cover" />
            </Link>
            
        </>,
    links: BookListConstructor(6)
    
}

const BookSeven = {
    title: "Kate the Chemist: The Birthday Blastoff",
    subtitle: <>The fourth installment of the Kate the Chemist fiction series
    <br /><br />
    Published: January 2022</>,
    desc: <>Kate the Chemist: Birthday Blastoff shows kids that everyone can be a scientist! Perfect for fans of the Girls Who Code series. What do birthday parties, magnets, and the periodic table have in common? They're all part of the science-themed escape room that Kate's science teacher puts on for their class. Will Kate and her friends be able to use their science know-how to crack the code before time runs out? From Kate the Chemist, chemistry professor and science entertainer as seen on The Late Show with Stephen Colbert, The Wendy Williams Show, and The Today Show, comes a clever and fun middle grade series that is the perfect introduction to STEM for young readers! Make Your Own Magnetic Slime! Experiment Inside!
    <br /><br />
    Praise for the Kate the Chemist fiction series:
    "Proves that science and fun go together like molecules in a polymer."
    --School Library Journal</>,
    image: BookBdayBlastoff,
    extra: 
        <><br /><br />Other books from this series:
            <br />
            <br />
            <Link to={`/books/bookeight`}>
                <LazyImage className="book-extra-img" src={ BookDragonsUnicorns } alt="Dragons vs. Unicorns book cover" />
            </Link>
            <Link to={`/books/bookfive`}>
                <LazyImage className="book-extra-img" src={ BookGreatEscape } alt="The Great Escape book cover" />
            </Link>
            <Link to={`/books/bookfour`}>
                <LazyImage className="book-extra-img" src={ BookStemNight } alt="The STEM Night Disaster book cover" />
            </Link>
            <Link to={`/books/booksix`}>
                <LazyImage className="book-extra-img" src={ BookPenguinProblems } alt="Some Penguin Problems book cover" />
            </Link>
        </>,

    links: BookListConstructor(7)
}

const BookEight = {
    title: "Kate the Chemist: Dragons vs. Unicorns",
    subtitle: <>The first installment of the Kate the Chemist fiction series</>,
    desc: <>Kate the Chemist: Dragons vs. Unicorns shows kids that everyone can be a scientist! Perfect for fans of the Girls Who Code series. From Kate the Chemist, chemistry professor and science entertainer as seen on The Late Show with Stephen Colbert, The Wendy Williams Show, and The Today Show, comes a clever and fun middle grade series that is the perfect introduction to STEM for young readers!
    <br /><br />
    Praise for the Kate the Chemist fiction series:
    "Proves that science and fun go together like molecules in a polymer."
    --School Library Journal
     <br /><br />
    "It's a great introduction to the basics of Chemistry that is readily accessible to a variety of ages . . . . The way the everyday chemistry is blended in is done seamlessly, and has [me and my ten-year-old son] noticing how we are all doing a little bit of science everyday."
    --GeekMom.com</>,
    image: BookDragonsUnicorns,
    extra: 
        <><br /><br />Other books from this series:
            <br />
            <br />
            <Link to={`/books/bookfive`}>
                <LazyImage className="book-extra-img" src={ BookGreatEscape } alt="The Great Escape book cover" />
            </Link>
            <Link to={`/books/bookfour`}>
                <LazyImage className="book-extra-img" src={ BookStemNight } alt="The STEM Night Disaster book cover" />
            </Link>
            <Link to={`/books/bookseven`}>
                <LazyImage className="book-extra-img" src={ BookBdayBlastoff } alt="The Birthday Blastoff book cover" />
            </Link>
            <Link to={`/books/booksix`}>
                <LazyImage className="book-extra-img" src={ BookPenguinProblems } alt="Some Penguin Problems book cover" />
            </Link>
        </>,
    links: BookListConstructor(8)
}


  export { BookOne, BookTwo, BookThree, BookFour, BookFive, BookSix, BookSeven, BookEight };
